export enum DatePreset {
  closedWeek = 'closed-week',
  closedMonth = 'closed-month',
  closedQuarter = 'closed-quarter',
  closedThreeMonths = 'closed-3months',
}
